document.addEventListener('DOMContentLoaded', function() {
    // Защита от двойной загрузки скрипта: обработчики делегированы на document,
    // повторная регистрация = двойное срабатывание каждого клика (в т.ч. двойное добавление)
    if (window.orViewCartPopupInit) return;
    window.orViewCartPopupInit = true;

    console.log('%c VIEW CART POPUP JS START', 'color: #00ff00; font-weight: bold;');

    const popup = document.querySelector('.or-view-cart-popup');
    const backdrop = document.querySelector('.or-view-cart-popup__backdrop');

    if (!popup || !backdrop) {
        console.error('Popup или backdrop не найден!');
        return;
    }

    // Получаем URL иконок из data-атрибутов
    const minusIconUrl = popup.dataset.minusIcon;
    const plusIconUrl = popup.dataset.plusIcon;

    console.log('Icon URLs:', { minusIconUrl, plusIconUrl });

    // === ФУНКЦИЯ ОЖИДАНИЯ ОБНОВЛЕНИЯ КОРЗИНЫ ===
    function waitForCartUpdate(variantId, expectedMinQty = 1) {
        return new Promise((resolve, reject) => {
            let attempts = 0;
            const check = () => {
                attempts++;
                fetch('/cart.js')
                    .then(r => {
                        if (!r.ok) throw new Error('Network error');
                        return r.json();
                    })
                    .then(cart => {
                        let qty = 0;
                        cart.items.forEach(item => {
                            if (item.variant_id == variantId) qty += item.quantity;
                        });
                        if (qty >= expectedMinQty) {
                            resolve(cart);
                        } else if (attempts < 5) {
                            setTimeout(check, 200);
                        } else {
                            reject(new Error('Timeout waiting for cart update'));
                        }
                    })
                    .catch(err => {
                        console.error('Check error:', err);
                        if (attempts < 5) {
                            setTimeout(check, 200);
                        } else {
                            reject(err);
                        }
                    });
            };
            check();
        });
    }

    // === ФУНКЦИЯ ФОРМАТИРОВАНИЯ ДЕНЕГ ===
    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    // === SAVINGS: скидки корзины + экономия от зачёркнутых (compare at) цен ===
    // /cart.js не отдаёт compare_at_price — берём его из /products/{handle}.js с кэшем
    const orProductCache = {};
    function updateSavings(cart) {
        const handles = [...new Set(cart.items.map(i => i.handle))];
        Promise.all(handles.map(h => orProductCache[h]
            ? Promise.resolve(orProductCache[h])
            : fetch('/products/' + h + '.js')
                .then(r => r.ok ? r.json() : null)
                .then(p => (orProductCache[h] = p))
                .catch(() => null)
        )).then(products => {
            const byId = {};
            products.filter(Boolean).forEach(p => p.variants.forEach(v => { byId[v.id] = v; }));
            let savings = cart.total_discount || 0;
            cart.items.forEach(i => {
                const v = byId[i.variant_id];
                if (v && v.compare_at_price && v.compare_at_price > i.final_price) {
                    savings += (v.compare_at_price - i.final_price) * i.quantity;
                    // Зачёркнутая compare-at цена в строке корзины (как на карточках компаньонов);
                    // клиентский рендер списка её не знает — дорисовываем здесь
                    document.querySelectorAll('.or-view-cart-popup__product-list-item[data-item-key="' + i.key + '"]').forEach(row => {
                        const priceBox = row.querySelector('.or-sticky-cart-price__container');
                        if (!priceBox) return;
                        let old = priceBox.querySelector('.organo-republic-old-price');
                        if (!old) {
                            old = document.createElement('span');
                            old.className = 'organo-republic-old-price';
                            priceBox.appendChild(old);
                        }
                        old.textContent = formatMoney(v.compare_at_price);
                    });
                }
            });
            document.querySelectorAll('[data-savings]').forEach(el => { el.textContent = formatMoney(savings); });
        }).catch(() => {});
    }

    // === СЧЁТЧИК НА ИКОНКЕ КОРЗИНЫ В ШАПКЕ ===
    function updateCartCount(cartData) {
        document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cartData.item_count < 100 ? cartData.item_count : '99+';
        });
    }

    // === ФУНКЦИЯ ОБНОВЛЕНИЯ UI КОРЗИНЫ ===
    function updateCartUI(cartData) {
        console.log('Updating cart UI with:', cartData);

        updateCartCount(cartData);

        // Обновляем цены
        const subtotalElement = document.querySelector('[data-subtotal]');
        if (subtotalElement) {
            subtotalElement.textContent = formatMoney(cartData.original_total_price);
        }

        const totalElement = document.querySelector('[data-total]');
        if (totalElement) {
            totalElement.textContent = formatMoney(cartData.total_price);
        }

        // Мгновенно — только скидки корзины, затем асинхронно доуточняем экономией от compare-at цен
        document.querySelectorAll('[data-savings]').forEach(el => { el.textContent = formatMoney(cartData.total_discount); });
        updateSavings(cartData);

        // Обновляем список товаров
        updateCartItemsList(cartData.items);
    }

    // === ФУНКЦИЯ ОБНОВЛЕНИЯ СПИСКА ТОВАРОВ ===
    function updateCartItemsList(items) {
        const container = document.querySelector('#or-cart-items');
        if (!container) return;

        if (items.length === 0) {
            // Та же разметка, что и в серверном рендере (halo-cart-sidebar.liquid)
            container.innerHTML = `
                <div class="or-cart-empty">
                    <svg class="or-cart-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.3h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="9.5" cy="20.5" r="1.4"/><circle cx="17.5" cy="20.5" r="1.4"/></svg>
                    <p class="or-cart-empty__title">Your cart is empty</p>
                    <p class="or-cart-empty__text">Add some seeds and grow something great</p>
                </div>`;
            return;
        }

        // Фото варианта: /cart.js отдаёт item.image = фото ТОВАРА (пока варианту не назначен
        // variant.image в админке). Каскад: уже показанное фото этой позиции (server-render
        // знает variant_gallery) -> галерея варианта с текущей PDP (OrgoVariantImage) -> item.image.
        const prevImages = {};
        container.querySelectorAll('.or-view-cart-popup__product-list-item').forEach(el => {
            const img = el.querySelector('.or-sticky-cart-product-image');
            const key = el.getAttribute('data-item-key');
            if (img && key) prevImages[key] = img.getAttribute('src');
        });

        let html = '';
        items.forEach(item => {
            const itemImage = prevImages[item.key] ||
                (window.OrgoVariantImage && window.OrgoVariantImage(item.variant_id)) ||
                item.image;
            // Полный тайтл варианта из line item property (or-variant-system) становится
            // ЗАГОЛОВКОМ строки (вместо тайтла перента) — отдельной строкой его не дублируем.
            // Без него: заголовок = product_title + строка стандартного variant_title
            // ("Default Title" и null не показываем).
            const fullVariantTitle = (item.properties && item.properties.Variant) || '';
            const stdVariantTitle = (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null') ? item.variant_title : '';
            const itemHeading = fullVariantTitle || item.product_title;
            const variantLabel = fullVariantTitle ? '' : stdVariantTitle;
            const showVariant = !!variantLabel;

            html += `
                <div class="or-view-cart-popup__product-list-item" data-item-key="${item.key}">
                    <div class="or-sticky-cart-product-image__container">
                        <img class="or-sticky-cart-product-image"
                             src="${itemImage}"
                             alt="${item.title.replace(/"/g, '&quot;')}"
                             loading="lazy">
                    </div>
                    <div class="or-sticky-cart-text__container">
                        <h3>${itemHeading}</h3>
                        ${showVariant ? `<p class="variant-title">${variantLabel}</p>` : ''}
                        <div class="or-sticky-cart-buy__container">
                            <div class="or-sticky-cart-price__container">
                                <span class="organo-republic-price">${formatMoney(item.final_price)}</span>
                                ${item.original_price > item.final_price ? 
                                    `<span class="organo-republic-old-price">${formatMoney(item.original_price)}</span>` : ''}
                            </div>
                            <div class="organo-republic-picker js-sidebar-picker">
                                <img src="${minusIconUrl}" alt="Minus" class="organo-republic-minus-sign" data-minus>
                                <span class="organo-republic-buy-button-text">${item.quantity}</span>
                                <img src="${plusIconUrl}" alt="Plus" class="organo-republic-plus-sign" data-plus>
                                <input type="hidden" value="${item.key}" data-line-key>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        });
        
        container.innerHTML = html;
    }

    // === ФУНКЦИЯ ОБНОВЛЕНИЯ КОРЗИНЫ ===
    function refreshCart() {
        return fetch('/cart.js')
            .then(r => {
                if (!r.ok) throw new Error('Network error');
                return r.json();
            })
            .then(cartData => {
                updateCartUI(cartData);
                return cartData;
            });
    }

    // === ГЛОБАЛЬНАЯ ФУНКЦИЯ ОТКРЫТИЯ ===
    window.openCartPopup = function() {
        console.log('openCartPopup: открываем попап с обновлением данных');
        
        refreshCart()
            .then(() => {
                popup.classList.add('active');
                backdrop.classList.add('active');
                document.body.classList.add('overflow-hidden');
            })
            .catch(err => {
                console.error('Ошибка обновления корзины:', err);
                // В случае ошибки все равно открываем попап
                popup.classList.add('active');
                backdrop.classList.add('active');
                document.body.classList.add('overflow-hidden');
            });
    };

    // === ФУНКЦИЯ ЗАКРЫТИЯ ===
    window.closeCartPopup = function() {
        console.log('closeCartPopup: закрываем попап');
        popup.classList.remove('active');
        backdrop.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    };

    // === ДЕЛЕГИРОВАНИЕ КЛИКОВ ===
    document.addEventListener('click', function(e) {
        const isCloseButton = e.target.closest('.or-view-cart-popup__close-button');
        const isBackdrop = e.target === backdrop;

        if (isCloseButton || isBackdrop) {
            console.log('Клик по закрытию:', { isCloseButton, isBackdrop });
            closeCartPopup();
        }
    });

    // === ПЛЮС / МИНУС (ТОЛЬКО ДЛЯ САЙДБАРА) ===
    // Оптимистичный UI + ОЧЕРЕДЬ: изменения по всем строкам копятся и уходят ОДНИМ
    // batch-запросом /cart/update.js (updates: {key: qty, ...}); следующий batch — только
    // после ответа. Параллельные одиночные запросы ловили 429 от Shopify, и зануленные
    // строки «зависали» в UI, оставаясь в корзине на сервере.
    // Список не перерисовываем при qty > 0 (DOM стабилен — клики не «промахиваются»),
    // полная перерисовка — только когда в batch было удаление строки.
    const orPendingUpdates = {};
    let orFlushTimer = null;
    let orUpdateInFlight = false;
    let orHadRemoval = false;

    function orFlushUpdates() {
        if (orUpdateInFlight) return; // дошлём после ответа
        const keys = Object.keys(orPendingUpdates);
        if (!keys.length) return;

        const updates = {};
        keys.forEach(k => { updates[k] = orPendingUpdates[k]; delete orPendingUpdates[k]; });
        if (Object.values(updates).some(q => q === 0)) orHadRemoval = true;
        orUpdateInFlight = true;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
        })
        .then(r => {
            if (!r.ok) { const e = new Error('Network error ' + r.status); e.status = r.status; throw e; }
            return r.json();
        })
        .then(cartData => {
            orUpdateInFlight = false;
            if (Object.keys(orPendingUpdates).length) {
                orFlushUpdates(); // за время запроса накопились новые изменения
                return;
            }
            if (orHadRemoval) {
                orHadRemoval = false;
                updateCartUI(cartData); // были удаления — перерисовываем список
                document.dispatchEvent(new CustomEvent('cart:updated'));
            } else {
                // Только цены и счётчик: состав не менялся
                updateCartCount(cartData);
                document.querySelectorAll('[data-subtotal]').forEach(el => { el.textContent = formatMoney(cartData.original_total_price); });
                document.querySelectorAll('[data-total]').forEach(el => { el.textContent = formatMoney(cartData.total_price); });
                document.querySelectorAll('[data-savings]').forEach(el => { el.textContent = formatMoney(cartData.total_discount); });
                updateSavings(cartData);
            }
        })
        .catch(err => {
            console.error('Ошибка обновления количества:', err);
            orUpdateInFlight = false;
            if (err && err.status === 429) {
                // Rate limit Shopify: возвращаем batch в очередь (не затирая более свежие клики)
                // и повторяем позже — зануления не «зависают», а доезжают до сервера
                Object.keys(updates).forEach(k => {
                    if (!(k in orPendingUpdates)) orPendingUpdates[k] = updates[k];
                });
                clearTimeout(orFlushTimer);
                orFlushTimer = setTimeout(orFlushUpdates, 1500);
            } else {
                orHadRemoval = false;
                refreshCart(); // откат к серверному состоянию
            }
        });
    }

    document.addEventListener('click', function(e) {
        const minus = e.target.closest('[data-minus]');
        const plus = e.target.closest('[data-plus]');
        if (!minus && !plus) return;

        // Проверяем, что клик был в пикере сайдбара
        const picker = e.target.closest('.js-sidebar-picker');
        if (!picker) return;

        // Останавливаем распространение
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const item = e.target.closest('.or-view-cart-popup__product-list-item');
        if (!item) return;

        const qtyElement = item.querySelector('.organo-republic-buy-button-text');
        const lineKey = item.querySelector('[data-line-key]').value;
        let qty = parseInt(qtyElement.textContent, 10);
        if (isNaN(qty)) qty = 1;

        qty = minus ? Math.max(0, qty - 1) : qty + 1;
        qtyElement.textContent = qty;
        item.style.opacity = qty === 0 ? '0.5' : '';

        orPendingUpdates[lineKey] = qty;
        clearTimeout(orFlushTimer);
        orFlushTimer = setTimeout(orFlushUpdates, 400);
    });

    // === ДОБАВЛЕНИЕ РЕКОМЕНДАЦИЙ ===
    document.addEventListener('click', function(e) {
        if (e.target.closest('[data-add-recommend]')) {
            const button = e.target.closest('[data-add-recommend]');
            // Кнопка может лежать внутри ссылки-карточки — гасим переход;
            // busy-флаг защищает от даблклика и повторного срабатывания
            e.preventDefault();
            e.stopPropagation();
            if (button.dataset.orBusy) return;
            button.dataset.orBusy = '1';
            setTimeout(() => { delete button.dataset.orBusy; }, 1500);

            const variantId = button.dataset.variantId;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    items: [{ 
                        id: variantId, 
                        quantity: 1 
                    }] 
                })
            })
            .then(r => {
                if (!r.ok) throw new Error('Network error');
                return r.json();
            })
            .then(() => {
                console.log('Рекомендация добавлена');
                // /cart/add.js уже подтвердил добавление — достаточно одного свежего /cart.js
                // (старый waitForCartUpdate опрашивал до 5 раз и разгонял rate limit Shopify)
                return fetch('/cart.js').then(r => r.json());
            })
            .then(cartData => {
                console.log('Обновление корзины подтверждено:', cartData);
                // Обновляем UI напрямую из cartData
                updateCartUI(cartData);
                
                // Открываем попап если закрыт
                if (!popup.classList.contains('active')) {
                    popup.classList.add('active');
                    backdrop.classList.add('active');
                    document.body.classList.add('overflow-hidden');
                }
                
                // Диспатчим событие для обновления других частей страницы
                document.dispatchEvent(new CustomEvent('cart:updated'));
            })
            .catch(err => {
                console.error('Ошибка добавления или обновления:', err);
                // Открываем попап даже при ошибке
                openCartPopup();
            });
        }
    });

    // === ОБНОВЛЕНИЕ КОРЗИНЫ (ПОЛНОЕ) ===
    document.addEventListener('cart:updated', function() {
        console.log('cart:updated — обновляем всю корзину');
        
        refreshCart()
            .catch(err => {
                console.error('Ошибка обновления корзины:', err);
            });
    });

    // Делаем функции глобальными для использования в других скриптах
    window.refreshCart = refreshCart;
    window.waitForCartUpdate = waitForCartUpdate;
    window.formatMoney = formatMoney;

    console.log('VIEW CART POPUP JS: Инициализация завершена');
});